import {
  ORIENTATION,
  PIXEL_BOUNDARY,
  SPLITSCREEN_TYPE,
  RATIO_BOUNDRY,
  DEFAULT_MIN_MAX_PANE_RATIO,
  PRIMARY_PANEL
} from './constants';

const hasSecondaryPixelLimits = pixelLimitsSecondary => pixelLimitsSecondary !== undefined;
const hasRightPanePrimary = primaryPanel => primaryPanel === PRIMARY_PANEL.RIGHT;
const hasLeftPanePrimary = primaryPanel => primaryPanel === PRIMARY_PANEL.LEFT;

const getAllowedMinPixelValue = (minPixels) => {
  let defaultPixels = minPixels;
  if (defaultPixels && (defaultPixels < PIXEL_BOUNDARY.MIN_PIXEL)) {
    defaultPixels = PIXEL_BOUNDARY.MIN_PIXEL;
  }
  return defaultPixels;
};

const handlePaneRatio = (values) => {
  const { pixelLimitsSecondary, splitScreenType, toggleTemporary, paneRatio, orientation } = values;
  let newPaneRatio;
  let minBoundry;
  let maxBoundry;
  if ((splitScreenType === SPLITSCREEN_TYPE.PERMANENT || (splitScreenType === SPLITSCREEN_TYPE.TEMPORARY)) && toggleTemporary === true) {
    if (paneRatio) {
      if (orientation === ORIENTATION.HORIZONTAL) {
        if (paneRatio.minRatio && paneRatio.minRatio < 5) {
          minBoundry = RATIO_BOUNDRY.MIN_BOUNDRY;
        } else {
          minBoundry = paneRatio.minRatio ? paneRatio.minRatio : DEFAULT_MIN_MAX_PANE_RATIO.HORIZONTAL_MIN;
        }
        if (paneRatio.maxRatio && paneRatio.maxRatio > 95) {
          maxBoundry = RATIO_BOUNDRY.MAX_BOUNDRY;
        } else {
          maxBoundry = paneRatio.maxRatio ? paneRatio.maxRatio : DEFAULT_MIN_MAX_PANE_RATIO.HORIZONTAL_MAX;
        }
        newPaneRatio = { minHeight: `${minBoundry}%`, maxHeight: `${maxBoundry}%` };
      } else {
        if (paneRatio.minRatio && paneRatio.minRatio < 5) {
          minBoundry = RATIO_BOUNDRY.MIN_BOUNDRY;
        } else {
          minBoundry = paneRatio.minRatio ? paneRatio.minRatio : DEFAULT_MIN_MAX_PANE_RATIO.VERTICAL_MIN;
        }
        if (paneRatio.maxRatio && paneRatio.maxRatio > 95) {
          maxBoundry = RATIO_BOUNDRY.MAX_BOUNDRY;
        } else {
          maxBoundry = paneRatio.maxRatio ? paneRatio.maxRatio : DEFAULT_MIN_MAX_PANE_RATIO.VERTICAL_MAX;
        }
        newPaneRatio = { minWidth: `${minBoundry}%`, maxWidth: `${maxBoundry}%` };
      }
    } else if (hasSecondaryPixelLimits(pixelLimitsSecondary)) {
      if (orientation === ORIENTATION.HORIZONTAL) {
        newPaneRatio = { minHeight: `${getAllowedMinPixelValue(pixelLimitsSecondary.minPixel)}px`, maxHeight: `${pixelLimitsSecondary.maxPixel}px` };
      } else {
        newPaneRatio = { minWidth: `${getAllowedMinPixelValue(pixelLimitsSecondary.minPixel)}px`, maxWidth: `${pixelLimitsSecondary.maxPixel}px` };
      }
    }
  } else if (!toggleTemporary && hasSecondaryPixelLimits(pixelLimitsSecondary) && splitScreenType === 'permanent') {
    if (orientation === ORIENTATION.HORIZONTAL) {
      newPaneRatio = { minHeight: `${getAllowedMinPixelValue(pixelLimitsSecondary.minPixel)}px`, maxHeight: `${pixelLimitsSecondary.maxPixel}px` };
    } else {
      newPaneRatio = { minWidth: `${getAllowedMinPixelValue(pixelLimitsSecondary.minPixel)}px`, maxWidth: `${pixelLimitsSecondary.maxPixel}px` };
    }
  }

  return newPaneRatio;
};

export { handlePaneRatio, hasLeftPanePrimary, hasRightPanePrimary, hasSecondaryPixelLimits, getAllowedMinPixelValue };